const colors = {
    bloodOrange: '#ff4700',
    brownishGrey: '#666666',
    warmGrey: '#999999',
    black: '#363636',
    white: '#fff',
    white2: '#e5e5e5',
    white3: '#fafafa',
    white4: '#f6f6f6',
};

export default colors;



// WEBPACK FOOTER //
// ./src/config/themeColors.js